import React from 'react';
import { PhoneBlueSM, WhatsappWhiteSM } from '../../../../components/Icons';
import { ModalProps } from '../../../../components/Modal';
import { SimpleModal } from '../../../../components/SimpleModal';
import { Button } from '../../../../components';
import { ReactComponent as WarningModal } from '../../../../assets/warningModal.svg';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { useScheduleContext } from '../../../../contexts/ScheduleContext';
import { useServiceContext } from '../../../../contexts/ServiceContext';
import { useSpecialistContext } from '../../../../contexts/SpecialistContext';
import { useModuleContext } from '../../../../contexts/ModuleContext';
import { FirebaseEvents } from '../../../../utils/enums/firebase-events';

// import { Container } from './styles';

export type AgeGroupModalProps = Pick<ModalProps, 'visible' | 'onClose'>;

const AgeGroupModal: React.FC<AgeGroupModalProps> = ({ onClose, visible }) => {
  const { logEvent } = useAnalytics();
  const { selectedItem, scheduleSpecialistSelected } = useScheduleContext();
  const { selectedService } = useServiceContext();
  const { selectedSpecialist } = useSpecialistContext();
  const { selectedItemToSchedule } = useModuleContext();

  return (
    <SimpleModal
      visible={visible}
      onClose={onClose}
      title="Este profissional não atende a sua faixa etária."
      subtitle="Por gentileza, busque por outro especialista ou entre em contato com a central de atendimento pelos canais."
      mainIcon={<WarningModal />}
      customFooterContainer={
        <>
          <Button
            title="Enviar mensagem"
            onClick={() => {
              logEvent({
                eventName: FirebaseEvents.schedule_redirect_support_whatsapp,
                eventParams: {
                  service_id: selectedService.id,
                  service_name: selectedService.name,

                  ...(selectedItemToSchedule === 'SPECIALIST'
                    ? {
                        product_name: selectedSpecialist?.name,
                        product_id: selectedSpecialist?.id,
                        unit_id: scheduleSpecialistSelected?.unit?.catalogId,
                        unit_name: scheduleSpecialistSelected?.unit?.name,
                        attendanceType: scheduleSpecialistSelected?.attendanceType
                      }
                    : {}),
                  ...(selectedItemToSchedule !== 'SPECIALIST'
                    ? {
                        product_name: selectedItem?.productName,
                        product_id: selectedItem?.productId,
                        unit_id: selectedItem?.unit?.catalogUnitId,
                        unit_name: selectedItem?.unit?.name,
                        attendanceType: selectedItem?.careType
                      }
                    : {}),
                  phone: '551136202550',
                  reason: 'age group restrictions'
                }
              });

              window.open('https://wa.me/551136202550');
            }}
            iconLeft={<WhatsappWhiteSM />}
          />
          <Button
            title="Ligar para central"
            secondary
            iconLeft={<PhoneBlueSM />}
            onClick={() => {
              logEvent({
                eventName: FirebaseEvents.schedule_redirect_call_center,
                eventParams: {
                  service_id: selectedService.id,
                  service_name: selectedService.name,

                  ...(selectedItemToSchedule === 'SPECIALIST'
                    ? {
                        product_name: selectedSpecialist?.name,
                        product_id: selectedSpecialist?.id,
                        unit_id: scheduleSpecialistSelected?.unit?.catalogId,
                        unit_name: scheduleSpecialistSelected?.unit?.name,
                        attendanceType: scheduleSpecialistSelected?.attendanceType
                      }
                    : {}),
                  ...(selectedItemToSchedule !== 'SPECIALIST'
                    ? {
                        product_name: selectedItem?.productName,
                        product_id: selectedItem?.productId,
                        unit_id: selectedItem?.unit?.catalogUnitId,
                        unit_name: selectedItem?.unit?.name,
                        attendanceType: selectedItem?.careType
                      }
                    : {}),
                  phone: '551121518709'
                }
              });
              window.open('tel:+551121518709');
            }}
          />
        </>
      }
    />
  );
};

export default AgeGroupModal;
